<cds-modal-dialog [(isOpen)]="showDialog" >
    <div cdsModalInitialFocus
      class="cds-modal-content"
      role="dialog"
      tabindex="0"
    >

        <div class="cds-modal-content__body">
            <div class="cds-modal-content__body__left-part">
                <img
                class="cds-modal-content__body__left-part__logo"
                [src]="citiLogoUrl"  [cache]="citiLogoUrl" [lazyload]="citiLogoUrl" alt="" />

                <h1 class="cds-modal-content__body__left-part__title" [innerHTML]="suspendDialogParams?.dialogHeader"></h1>

                <div class="cds-modal-content__body__left-part__body" [innerHTML]="suspendDialogParams?.dialogBodyText"></div>

                <button class="cds-modal-content__body__left-part__close-btn btn btn-primary" (click)="closeSuspendDialog()">
                    {{ suspendDialogParams?.closeButtonText }}
                </button>
            </div>
            <div class="cds-modal-content__body__right-part">
                <img [src]="dialogRightImgUrl"  [cache]="dialogRightImgUrl" [lazyload]="dialogRightImgUrl" alt="" class="cds-image-square display-bottom" />
            </div>
        </div>
    </div>
</cds-modal-dialog>
